import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { userActions } from '../_actions';

function LoginPage() {
    const [inputs, setInputs] = useState({
        username: '',
        password: ''
    });
    const [submitted, setSubmitted] = useState(false);
	const { username, password } = inputs;
    const loggingIn = useSelector(state => state.authentication.loggingIn);
    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();
    const location = useLocation();

    // reset login status
    useEffect(() => { 
        dispatch(userActions.logout()); 
    }, []);

    function handleChange(e) {
        const { name, value } = e.target;
        setInputs(inputs => ({ ...inputs, [name]: value }));
    }

    function handleSubmit(e) {
        e.preventDefault();

        setSubmitted(true);
        if (username && password) {
            // get return url from location state or default to home page
        	console.log("--------------------- location.state: " + JSON.stringify(location.state));
            const { from } = location.state || { from: { pathname: "/applications" } };
            console.log("--------------------- from: " + JSON.stringify(from));
            dispatch(userActions.login(username, password, from));
        }
    }

    return (
    		
    		<div>
    			<div className="col-lg-3 offset-lg-4">
    			
    			
                <br/>

                <h1 className="text-center">EFP </h1>
                <h4 className="text-center"> ( Electronic Filing Platform ) </h4>
                <br/>


		            <form name="form" onSubmit={handleSubmit}>
		                <div className="form-group">
		                    <label>Username</label>
		                    <input type="text" name="username" value={username} onChange={handleChange} className={'form-control' + (submitted && !username ? ' is-invalid' : '')} />
		                    {submitted && !username &&
		                        <div className="invalid-feedback">Username is required</div>
		                    }
		                </div>
		                <div className="form-group">
		                    <label>Password</label>
		                    <input type="password" name="password" value={password} onChange={handleChange} className={'form-control' + (submitted && !password ? ' is-invalid' : '')} />
		                    {submitted && !password &&
		                        <div className="invalid-feedback">Password is required</div>
		                    }
		                </div>
		                <div className="form-group">
		                    <button className="btn btn-primary">
		                        {loggingIn && <span className="spinner-border spinner-border-sm mr-1"></span>}
		                        Login
		                    </button>
		                </div>
		                <div className="form-group">
		                {alert.message &&
		                    <div className={`alert ${alert.type}`}>{alert.message}</div>
		                }
		                {/* users.error && <span className="text-danger">ERROR: {users.error}</span> */}
		                </div>
		            </form>
		       </div>
	        <div className="col-lg-3 offset-lg-4">
				<h5>Need access or forgot your password</h5>
				<h5>Contact us ! ( 24/5 Support [Monday - Friday] ) </h5> 
				<h5>Phone: US +1  212-896-2830 opt 9</h5>
				<h5>Email: support@nyse.com</h5>
			</div>
		</div>
	
    );
}

export { LoginPage };